<h1 mat-dialog-title>
    {{ getTitleMessage }}
</h1>
<div mat-dialog-content>
    <p>
        {{ getBodyMessage }}
    </p>
</div>
<div class="form-footer">
    <button mat-button class="primary" (click)="close()">Close</button>
</div>
